// extracted by mini-css-extract-plugin
module.exports = {"restrictPermissionsContainer":"RestrictonOrganizationPermissions_restrictPermissionsContainer__1pQRx"};